import {
  COLUMN_TYPE_PREDICT_DEFAULT,
  COLUMN_TYPE_PREDICT_TREND,
  PREDICT_TREND,
} from "core/consts";
import { Chip, ChipProps } from "ds/ui/chip/chip";
import { newThemeColors } from "ds_legacy/materials/colors";
import { PROBABILITY_THRESHOLDS } from "dsl/ecosystems/PredictPage";
import {
  ArrowDownRightIcon,
  ArrowRightIcon,
  ArrowUpRightIcon,
} from "lucide-react";
import { useTranslations } from "translations";
import { CellProps, DefaultTextCell } from ".";
import { DefaultCellBodyText } from "../styles";

export const PredictStringCell = ({
  isAdmissionToday,
  testId,
  value,
}: CellProps<typeof COLUMN_TYPE_PREDICT_DEFAULT>) => {
  return (
    <DefaultTextCell
      testId={testId}
      message={value ?? ""}
      fontWeight={isAdmissionToday ? "bold" : undefined}
    />
  );
};

export const PredictTrendCell = ({
  isAdmissionToday,
  predict_trend,
  testId,
  value,
}: CellProps<typeof COLUMN_TYPE_PREDICT_TREND> & {
  isAdmissionToday?: boolean;
}) => {
  const translations = useTranslations();

  const getTrendIcon = () => {
    if (isAdmissionToday) return null;

    if (predict_trend === PREDICT_TREND.INCREASING) {
      return (
        <ArrowUpRightIcon
          aria-label={
            translations.predict.dashboard.dischargeProbabilityIncreased
          }
          color={newThemeColors.black}
          size={16}
        />
      );
    } else if (predict_trend === PREDICT_TREND.DECREASING) {
      return (
        <ArrowDownRightIcon
          aria-label={
            translations.predict.dashboard.dischargeProbabilityDecreased
          }
          color={newThemeColors.black}
          size={16}
        />
      );
    } else if (predict_trend === PREDICT_TREND.STEADY) {
      return (
        <ArrowRightIcon
          aria-label={translations.predict.dashboard.dischargeProbabilitySame}
          color={newThemeColors.black}
          size={16}
        />
      );
    }
    return null;
  };

  const getChipColor = (): ChipProps["color"] => {
    if (value >= PROBABILITY_THRESHOLDS.HIGH) {
      return "danger";
    } else if (value >= PROBABILITY_THRESHOLDS.MEDIUM) {
      return "warning";
    }
    return "success";
  };

  const icon = getTrendIcon();
  const chipColor = getChipColor();

  return (
    <DefaultCellBodyText
      data-testid={testId}
      fontWeight={isAdmissionToday ? "bold" : undefined}
    >
      <Chip
        color={chipColor}
        variant="flat"
        id={`${value}-${testId}`}
        endContent={icon}
      >
        {value} %
      </Chip>
    </DefaultCellBodyText>
  );
};
